function parseVnis(value) {
  try {
    return new Set(JSON.parse(value || "[]").map((vni) => String(vni)))
  } catch (_error) {
    return new Set()
  }
}

function initializeForm(form) {
  if (form.dataset.evpnVrfValidationMounted === "true") return

  const input = form.querySelector("#evpn_vrf_vni")
  const error = form.querySelector("[data-evpn-vrf-vni-error]")
  if (!input || !error) return

  const usedL2Vnis = parseVnis(form.dataset.usedL2Vnis)
  const usedL3Vnis = parseVnis(form.dataset.usedL3Vnis)
  const usedL3VnisByRdId = new Map(
    [...usedL3Vnis].map((vni) => [Number(vni) & 0xffff, vni])
  )

  const validate = () => {
    const value = String(input.value || "").trim()
    let message = ""

    if (value === "5000") {
      message = "L3VNI 5000 is reserved for public EVPN."
    } else if (value && usedL2Vnis.has(value)) {
      message = `L3VNI ${value} is already used as an L2VNI.`
    } else if (value && usedL3Vnis.has(value)) {
      message = `L3VNI ${value} is already used as an L3VNI.`
    } else if (value && usedL3VnisByRdId.has(Number(value) & 0xffff)) {
      const rdId = Number(value) & 0xffff
      const conflictingVni = usedL3VnisByRdId.get(rdId)
      message = `L3VNI ${value} produces RD ID ${rdId}, which is already used by L3VNI ${conflictingVni}.`
    }

    input.setCustomValidity(message)
    error.textContent = message
    error.hidden = !message
    input.closest(".form-group")?.classList.toggle("has-error", !!message)
    return !message
  }

  input.addEventListener("input", validate)
  input.addEventListener("change", validate)
  form.addEventListener("submit", (event) => {
    if (validate()) return
    event.preventDefault()
    input.reportValidity()
    input.focus()
  })
  validate()
  form.dataset.evpnVrfValidationMounted = "true"
}

export function initializeEvpnVrfForms() {
  document.querySelectorAll("[data-evpn-vrf-form]").forEach(initializeForm)
}
